export const replyByImLabel = "dIz2Cc";
export const replyAllRecipientsByImLabel = "_oyYNb";
export const replyAllParticipantsByImLabel = "Yi8are";
export const replyByImDefaultLabel = "crcQfd";
export const replyByImWin32Label = "ir42j";
export const replyAllByImWin32Label = "Pdg4Ue";
export default {replyByImLabel,replyAllRecipientsByImLabel,replyAllParticipantsByImLabel,replyByImDefaultLabel,replyByImWin32Label,replyAllByImWin32Label};